import { render, staticRenderFns } from "./PageTabsView.vue?vue&type=template&id=05054d8f&"
import script from "./PageTabsView.vue?vue&type=script&lang=js&"
export * from "./PageTabsView.vue?vue&type=script&lang=js&"
import style0 from "./PageTabsView.vue?vue&type=style&index=0&id=05054d8f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports